import BlogsScreen from './containers/blogsScreen'

export {default as BlogsScreenLayout} from './components/blogsScreenLayout'

export default BlogsScreen
